module.exports = __webpack_public_path__ + "static/media/energy-outgoing-xl.cc5e8797.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/energy-outgoing-xl.jpg
// module id = 408
// module chunks = 12